import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Table,
  InputNumber,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Card,
  message,
  notification,
  Checkbox,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import ApprovalButtons from "../Forms/ApprovalButtons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import moment from "moment";
import { Typography } from "antd";
import config from "../../util/ApiforContext";
import { useLocation } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const UpdatePurchaseRequest = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [materialsData, setMaterialsData] = useState({
    data: [],
    loading: false,
  });
  const [rows, setRows] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [existingFiles, setExistingFiles] = useState([]);
  const [materlalCategorySelect, setMaterialCategorySelect] = useState({
    data: [],
    loading: false,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode") || "edit"; // default edit
  const isViewMode = mode === "view";
  const [tenantName, setTenantName] = useState("");
  const [firmTransactionProjectTypeList, setFirmTransactionProjectTypeList] =
    useState({
      data: [],
      loading: false,
    });

  const [firmSelected, setFirmSelected] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    // Eğer ID varsa, güncelleme için veriyi çek
    if (props.match.params.id) {
      // 1. PurchaseRequest'i getir
      RequestHandler.get(
        `/PurchaseRequest/GetById/${props.match.params.id}`
      ).then((response) => {
        if (!response) {
          message.error("Talep verileri alınamadı.");
          return;
        }

        const data = response;
        setData(response);

        // Form doldurma
        form.setFieldsValue({
          name: data?.name,
          description: data?.description,
          desiredDeliveryDate: data?.desiredDeliveryDate
            ? moment(data?.desiredDeliveryDate)
            : null,
          id: data?.id,
          firmId: data?.firmId || null,
          detailedDescription: data?.detailedDescription,
          purposeOfPurchasing: data?.purposeOfPurchasing,
          transactionProjectTypeId: data?.transactionProjectTypeId || null,
        });

        // Satırları set et
        setRows(
          (data.purchaseRequestItems || []).map((item) => ({
            ...item,
            key: item.id || Date.now() + Math.random(), // benzersiz key
          }))
        );

        // Dosyaları set et
        setExistingFiles(data.files || []);

        // 2. Firm bilgisi getir
        if (data?.firmId) {
          RequestHandler.get(
            `/PurchaseRequest/GetByFirmId/${data?.firmId}`
          ).then((firm) => {
            if (firm) {
              setFirmSelect({
                data: [firm],
                loading: false,
              });
            }
          });
        }

        // 3. PurchaseRequestItems içindeki stockId'leri topla
        const stockIds = (data.purchaseRequestItems || [])
          .map((item) => item.stockId)
          .filter(Boolean); // null/undefined olanları çıkar

        if (stockIds.length > 0) {
          // 4. OData filter string (Guid için)
          const filter = `id in (${stockIds.map((id) => `'${id}'`).join(",")})`;

          // 5. İlgili Stock kayıtlarını çek
          RequestHandler.get(
            `/PurchaseRequest/GetStockList?$filter=${encodeURIComponent(
              filter
            )}`
          ).then((stockResponse) => {
            if (stockResponse) {
              setMaterialsData({
                data: stockResponse || [],
                loading: false,
              });
            } else {
              setMaterialsData({ data: [], loading: false });
            }
          });
        } else {
          // hiç stockId yoksa boş dön
          setMaterialsData({ data: [], loading: false });
        }

        // 6. Firma seçiliyse projeleri getir
        if (data?.firmId) {
          setFirmSelected(true);
          RequestHandler.get(
            `/FirmTransactionProjectType/GetListByFirmId/${data?.firmId}`
          ).then((res) => {
            setFirmTransactionProjectTypeList({
              data: res || [],
              loading: false,
            });
          });
        }
      });
    } else {
      // Uyarı ver
      notification.warning({
        message: "Uyarı",
        description: "Güncelleme için geçerli bir talep kaydı bulunamadı.",
      });
    }
  }, [props.match.params.id]);

  useEffect(() => {
    RequestHandler.get(`/MaterialCategory`).then((response) => {
      setMaterialCategorySelect({
        data: response?.value,
        loading: false,
      });
    });
  }, []);

  useEffect(() => {
    RequestHandler.get(
      `/Tenant/GetById/${localStorage.getItem("tenantId")}`
    ).then((res) => {
      setTenantName(res?.name);
    });
  }, []);

  const addRow = () => {
    setRows([
      ...rows,
      {
        key: Date.now(),
        quantity: null,
        unit: "",
        name: "",
        stockCode: "",
        stockId: null,
        materialCategoryId: null,
      },
    ]);
  };

  const updateRow = (key, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.key === key) {
          const updatedRow = { ...row, [field]: value };

          // Stock seçildiğinde ad & kod doldur
          if (field === "stockId") {
            if (value) {
              const selected = materialsData.data.find((m) => m.id === value);
              if (selected) {
                updatedRow.name = selected.name;
                updatedRow.stockCode = selected.stockCode;
                updatedRow.unit = selected.unit || "";
                updatedRow.materialCategoryId =
                  selected.materialCategoryId || null;
              }
            } else {
              // Malzeme temizlenirse kategori de boşalsın
              updatedRow.materialCategoryId = null;
            }
          }

          return updatedRow;
        }
        return row;
      })
    );
  };

  const deleteRow = (key) => {
    setRows((prev) => prev.filter((row) => row.key !== key));
  };

  const columns = [
    {
      title: "Malzeme",
      dataIndex: "stockId",
      render: (value, record) => (
        <Select
          placeholder="(Opsiyonel). En az 2 harf giriniz.."
          value={value}
          allowClear
          showSearch
          onSearch={onMaterialSearch}
          onChange={(val) => updateRow(record.key, "stockId", val)}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          disabled={isViewMode}
        >
          {materialsData?.data?.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Kategori",
      dataIndex: "materialCategoryId",
      render: (value, record) => (
        <Form.Item style={{ marginBottom: 0 }}>
          <Select
            placeholder="Kategori"
            value={value}
            allowClear
            disabled={true}
            showSearch
            onSearch={onMaterialCategorySearch}
            onChange={(val) => updateRow(record.key, "materialCategoryId", val)}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {materlalCategorySelect?.data?.map((m) => (
              <Option key={m.id} value={m.id}>
                {m.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "quantity", val)}
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Birim",
      dataIndex: "unit",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Sil",
      key: "action",
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => deleteRow(record.key)}
          disabled={isViewMode}
        ></Button>
      ),
    },
  ];

  const onSuccess = () => {
    form.resetFields();
    setFiles([]);
    setTimeout(
      function () {
        history.push(`/purchase-request-list`);
      }.bind(this),
      2000
    );
  };

  const onFinish = (values) => {
    // Hatalı satırları tespit et
    const invalidRows = rows.filter((row) => {
      const hasMaterial = row.stockId || (row.name && row.name.trim() !== "");
      const validQuantity =
        typeof row.quantity === "number" && row.quantity > 0;
      const hasUnit = row.unit && row.unit.trim() !== "";

      return !hasMaterial || !validQuantity || !hasUnit;
    });

    if (invalidRows.length > 0) {
      invalidRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Hatalı Malzeme Satırı",
          description:
            row.name && row.name.trim() !== ""
              ? `${row.name} satırında eksik veya hatalı bilgi var.`
              : `Malzeme Adı belirtilmemiş satırda eksik veya hatalı bilgi var.`,
          placement: "topRight",
        });
      });
      return; // Hatalıysa devam etme
    }

    // Her şey uygunsa payload hazırla
    const payload = {
      ...values,
      desiredDeliveryDate: values.desiredDeliveryDate
        ? values.desiredDeliveryDate.format("YYYY-MM-DD")
        : null,
      purchaseRequestItemUpdateDtos: rows,
      documentVms: existingFiles,
      //   files: files.map((f) => f.originFileObj),
    };
    const formData = new FormData();

    formData.append("jsonString", JSON.stringify(payload));
    // Files alanı: her dosyayı ayrı ayrı 'Files' olarak append et
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    // API isteği (axios veya kendi RequestHandler’a göre)
    RequestHandler.put(
      `/PurchaseRequest`,
      formData,
      true,
      {},
      "multipart/form-data"
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onMaterialSearch = (value) => {
    if (value.length >= 2) {
      setMaterialsData({ data: [], loading: true });

      RequestHandler.get(
        `/Stock?$select=id,name,stockCode,unit,materialCategoryId,materialCategoryName&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("stockCode", value)}`
      ).then((res) => {
        setMaterialsData({ data: res.value, loading: false });
      });
    } else {
      setMaterialsData({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const fileDownload = (file) => {
    window.open(
      `${config.apiUrl}/FileDownload/${file}?t=${RequestHandler.getToken()}`
    );
  };

  const onMaterialCategorySearch = (value) => {
    if (value.length >= 2) {
      setMaterialCategorySelect({ data: [], loading: true });

      RequestHandler.get(
        `/MaterialCategory?$select=id,name,code&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("code", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setMaterialCategorySelect({ data: res.value, loading: false });
      });
    } else {
      setMaterialCategorySelect({ data: [], loading: false });
    }
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onChangeFirm = (value) => {
    if (value) {
      // Firma seçilirse projeleri getir
      setFirmTransactionProjectTypeList({ data: [], loading: true });
      RequestHandler.get(
        `/FirmTransactionProjectType/GetListByFirmId/${value}`
      ).then((res) => {
        setFirmTransactionProjectTypeList({ data: res, loading: false });
      });
      setFirmSelected(true);
    } else {
      // Firma temizlenirse projeleri de temizle
      setFirmTransactionProjectTypeList({ data: [], loading: false, data: [] });
      setFirmSelected(false);
    }
  };



  return (
    <>
      <Title level={3}>Talep Güncelleme</Title>

      <Form
        form={form}
        name="update-purchase-request"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row justify="center" style={{ padding: 20, paddingLeft: "20%" }}>
          <Col xs={24} md={20} lg={24}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Row gutter={[16, 16]}>
                {/* Sol taraf */}
                <Col xs={24} md={18}>
                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Talep Bilgileri
                      </span>
                    }
                    bordered={false}
                  >
                    <Form.Item
                      label="Talep Kodu :"
                      name="name"
                      rules={[
                        { required: true, message: "Lütfen kod giriniz" },
                      ]}
                    >
                      <Input disabled={isViewMode} />
                    </Form.Item>
                    <Form.Item
                      label="Talep Başlığı :"
                      name="description"
                      // rules={[{ required: true, message: "Lütfen Açıklama giriniz" }]}
                    >
                      <Input.TextArea rows={3} disabled={isViewMode} />
                    </Form.Item>
                    <Form.Item label="Proje Adı/Ünvanı :" name="firmId">
                      <Select
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onFirmSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={firmSelect.loading}
                        disabled={isViewMode}
                        onChange={onChangeFirm}
                      >
                        {firmSelect.data.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            code={item.firmBranchNumber}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Teslimat Deposu :"
                      name="transactionProjectTypeId"
                      rules={[
                        {
                          required: firmSelected,
                          message: "Lütfen teslimat deposu seçiniz.",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Teslimat Deposu"
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={firmTransactionProjectTypeList.loading}
                      >
                        {firmTransactionProjectTypeList.data.map((item) => (
                          <Select.Option
                            key={item.transactionProjectTypeId}
                            value={item.transactionProjectTypeId}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="İstenen Teslim Tarihi :"
                      name="desiredDeliveryDate"
                    >
                      <DatePicker
                        format="YYYY-MM-DD"
                        style={{ width: "30%" }}
                        disabledDate={(current) => {
                          // bugün dahil öncesini kapat
                          return current && current < moment().startOf("day");
                        }}
                        disabled={isViewMode}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Malzeme Alım Amacı ve Kullanilacağı Yer :"
                      name="purposeOfPurchasing"
                    >
                      <Input.TextArea rows={3} />
                    </Form.Item>
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Talep Malzemeleri
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16 }}
                  >
                    <Button
                      type="dashed"
                      onClick={addRow}
                      icon={<PlusOutlined />}
                      style={{ marginBottom: 10 }}
                      disabled={isViewMode}
                    >
                      Satır Ekle
                    </Button>
                    <Table
                      columns={columns}
                      dataSource={rows}
                      pagination={false}
                      rowKey="key"
                      scroll={{ x: "max-content" }}
                    />

                    <br></br>
                    <br></br>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: "bold" }}>
                          Malzeme Hakkında Açıklama, Teknik Detaylar ve Varsa
                          Marka Bilgileri :
                        </span>
                      }
                      name="detailedDescription"
                    >
                      <Input.TextArea rows={6} />
                    </Form.Item>
                  </Card>

                  {/* //Onaylar */}

                  {data?.statusByte == 0 && (
                    <Card
                      bordered
                      style={{ marginBottom: 24 }}
                      hidden={!(data?.statusByte == 0)}
                    >
                      <Title level={4}>BİRİNCİ ONAY (Depo Sorumlusu)</Title>
                      <Text strong>
                        Onaylayan Depo Sorumlusu:{" "}
                        {localStorage.getItem("userName")}
                      </Text>
                      <Form.Item
                        name="depoOnay"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: "Lütfen onay kutularını işaretleyiniz.",
                          },
                        ]}
                      >
                        <Checkbox.Group
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          <br></br>
                          <Checkbox
                            value="noStockInDepot"
                            style={{ marginLeft: 0 }}
                          >
                            Talepte bulunulan malzemeler birimin depo
                            stoklarında yoktur
                          </Checkbox>
                          <br></br>
                          <Checkbox
                            value="noStockInOtherDepot"
                            style={{ marginLeft: 0 }}
                          >
                            Talepte bulunulan malzemeler {tenantName}’nin diğer
                            birim ve depolarından da sorulmuş ve oralarda da
                            olmadığı bilgisi alınmıştır.{" "}
                            <Text type="secondary">
                              (Not: Talep edilen malzeme diğer depolarda olduğu
                              halde getirme maliyeti daha yüksek olacaksa bu
                              kısım yine de onaylanmalıdır.)
                            </Text>
                          </Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Card>
                  )}

                  <Card bordered hidden={!(data?.statusByte == 1)}>
                    <Title level={4}>
                      İKİNCİ ONAY (Birim/Şantiye Amiri/Yetkilisi)
                    </Title>
                    <Text strong>
                      Onaylayan Birim Yetkilisi:{" "}
                      {localStorage.getItem("userName")}
                    </Text>
                    <Form.Item name="approveUnit" valuePropName="checked">
                      <Checkbox.Group
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 8,
                        }}
                      >
                        <br></br>
                        <Checkbox value="needApprove">
                          Talepte bulunulan malzemeler birimin ihtiyaçları
                          dahilindedir. Miktarı ve kullanılacağı bildirilen yer
                          doğrudur.
                        </Checkbox>
                        <br></br>
                        <Checkbox
                          value="technicalDetailsCorrect"
                          style={{ marginLeft: 0 }}
                        >
                          Malzemeler için yazılan teknik detaylar (teknik
                          şartname) doğrudur.
                        </Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Dosyalar
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16 }}
                  >
                    {/* API'den gelen dosyalar */}
                    {existingFiles.length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        {existingFiles.map((file) => (
                          <div
                            key={file.id}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              border: "1px solid #ddd",
                              padding: "8px 12px",
                              marginBottom: 8,
                              borderRadius: 4,
                            }}
                          >
                            <span>{file.fileName.split("\\").pop()}</span>
                            <div>
                              <Button
                                type="link"
                                onClick={() => fileDownload(file.fileName)}
                              >
                                İndir
                              </Button>
                              <Button
                                type="link"
                                danger
                                onClick={() =>
                                  setExistingFiles((prev) =>
                                    prev.filter((f) => f.id !== file.id)
                                  )
                                }
                                hidden={isViewMode}
                              >
                                Sil
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Yeni dosya yükleme alanı */}
                    <Upload
                      multiple
                      beforeUpload={() => false}
                      onChange={({ fileList }) => setFiles(fileList)}
                      fileList={files}
                    >
                      <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                    </Upload>
                  </Card>

                  {!isViewMode && (
                    <Row justify="space-between">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          icon={<PlusOutlined />}
                          htmlType="submit"
                          loading={loading}
                        >
                          Güncelle
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              {/* En altta, View Mode’da gösterilecek */}
              {isViewMode && (
                <ApprovalButtons
                  entityId={data?.id}
                  entityType="purchaseRequest"
                  status={data?.statusByte}
                  canApprove={data?.canApprove}
                  canReject={data?.canReject}
                  canCancel={data?.canCancel}
                  isAdmin={data?.isAdmin}
                  onSuccess={onSuccess}
                  form={form}
                  documentVms={existingFiles}
                  files={files}
                />
              )}
            </Form>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UpdatePurchaseRequest;
